import { useMemo, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { insuranceProviders } from 'constants/forms';

import BaseSelect from './base';

import type { Option } from './base';

interface Props {
  value?: Option[];
  width?: string;
  showSelectAll?: boolean;
  onChange: (e: Option[]) => void;
}

const InsuranceSelect: FC<Props> = ({
  onChange,
  value,
  showSelectAll,
  width = '100%',
}) => {
  const { t } = useTranslation();
  const options = useMemo(() => {
    return insuranceProviders.map((item) => ({
      label: item.label,
      value: item.value,
      title: item.label,
    }));
  }, []);

  return (
    <BaseSelect
      width={width}
      label={t('labels.insurance')}
      data-cy="filter-insurance"
      placeholder={t('labels.all')}
      mode="multiple"
      showSelectAll={showSelectAll}
      options={options}
      value={value}
      onChange={(newValues) => {
        const items = Array.isArray(newValues) ? newValues : [newValues];
        onChange(items);
      }}
    />
  );
};

export default InsuranceSelect;
